import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", { d: "M9.1 5.768a.75.75 0 0 0-1.341-.67l-1.711 3.42a.75.75 0 0 0 .67 1.086h1.354L6.903 11.94a.75.75 0 0 0 1.342.67l1.711-3.42a.75.75 0 0 0-.67-1.086H7.931L9.1 5.767Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M1.656 14.15c0 .8.65 1.45 1.45 1.45h9.8l-.01.01c.8 0 1.45-.65 1.45-1.45V8.6h.65a.751.751 0 0 0 .53-1.28l-6.5-6.5c-.27-.28-.63-.43-1.02-.43s-.76.15-1.03.42l-6.5 6.5c-.21.22-.28.54-.16.82.11.28.39.46.69.46h.65v5.56Zm1.49-6.3c0-.3-.17-.56-.42-.68l5.24-5.29 5.3 5.3c-.25.12-.42.38-.42.67l.05 6.26c-1.343 0-2.38-.002-3.237-.003a236.153 236.153 0 0 0-6.513.053V7.85Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  o,
  n
];
function r(s, a) {
  return t(), l("svg", c, [...d]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
